import { Title } from "@/components/common/typography/Title";
import { CarouselCards } from "@/components/common/caroussel/CarousselCards";
import { Icon } from "@iconify/react";
import { servicesImages } from "@/data/services";
import { imageAlts } from "@/utils/seo/imageAlts";

const serviceImageAlts = [
  imageAlts.services.meetingRooms.main,
  imageAlts.services.meetingRooms.phoneBox,
  imageAlts.services.meetingRooms.largeRoom,
  imageAlts.services.cafeteria.main,
  imageAlts.services.cafeteria.terrace,
  imageAlts.services.cafeteria.kitchen,
  imageAlts.services.greenSpaces.patio,
  imageAlts.services.greenSpaces.terrace,
  imageAlts.services.greenSpaces.rooftop,
  imageAlts.services.amenities.common,
  imageAlts.services.amenities.recreation,
  imageAlts.services.amenities.facilities,
];

export const ServicesSection = () => {
  return (
    <section
      className="flex flex-col gap-12 py-20 text-black ph:gap-0"
      id="services"
    >
      <div className="flex flex-col gap-12 px-4 ph:px-24 ph:pb-12 md:px-48 lg:px-72 xl:px-96">
        <Title title="Services" />
      </div>

      <CarouselCards
        images={servicesImages}
        imageAlts={serviceImageAlts}
        defaultAlt="Services et équipements du coworking Espace Cadet Paris 9"
      />

      <div className="grid grid-cols-1 gap-8 px-4 pt-12 ph:px-24 md:grid-cols-2 md:px-48 lg:px-72 xl:grid-cols-4 xl:px-96">
        <div className="rounded-lg bg-white p-6 shadow-md">
          <div className="mb-4 flex">
            <div className="mr-3 h-auto w-1 self-stretch rounded-full bg-primary"></div>
            <h3 className="text-xl font-bold text-black">Salles de réunion</h3>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>8 salles de réunion de 3 à 16 personnes</span>
            </li>
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>1 phone box</span>
            </li>
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>
                Immeuble avec la fibre, salles de réunion incluses dans les
                tarifs
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-lg bg-white p-6 shadow-md">
          <div className="mb-4 flex">
            <div className="mr-3 h-auto w-1 self-stretch rounded-full bg-primary"></div>
            <h3 className="text-xl font-bold text-black">Cafétéria</h3>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>
                2 espaces distincts, l&apos;un donnant sur un patio intérieur
                végétalisé, l&apos;autre sur une grande terrasse aménagée
              </span>
            </li>
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>
                Des cuisines équipées: frigo, micro-ondes et lave-vaisselle
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-lg bg-white p-6 shadow-md">
          <div className="mb-4 flex">
            <div className="mr-3 h-auto w-1 self-stretch rounded-full bg-primary"></div>
            <h3 className="text-xl font-bold text-black">
              Espaces verts et aérés
            </h3>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>Un patio arboré de 70 m² au RDC, aménagé</span>
            </li>
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>
                Une terrasse végétalisée de 90 m² au 2e étage, aménagée pour les
                déjeuners et les réunions en plein air
              </span>
            </li>
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>
                Un rooftop au 8e étage, avec une vue à 360° sur tout Paris,
                aménagé avec mobilier et barbecue
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-lg bg-white p-6 shadow-md">
          <div className="mb-4 flex">
            <div className="mr-3 h-auto w-1 self-stretch rounded-full bg-primary"></div>
            <h3 className="text-xl font-bold text-black">Autres commodités</h3>
          </div>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>Une douche, sanitaires Hommes/Femmes à chaque étage</span>
            </li>
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>Un babyfoot, des jeux de société</span>
            </li>
            <li className="flex items-start">
              <Icon
                icon="mdi:check-circle"
                className="mr-2 mt-0.5 h-5 w-5 flex-shrink-0 text-primary"
              />
              <span>
                Un partenariat avec les Joyeux Recycleurs (recyclage des
                capsules Nespresso, bouteilles, canettes, papier et mégots)
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
